import { render } from "./ControlTheSizeOfTheSpace.vue?vue&type=template&id=300d0bc8&ts=true"
import script from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=ts"
export * from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=ts"

import "./ControlTheSizeOfTheSpace.vue?vue&type=style&index=0&id=300d0bc8&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__